export default function Features() {
  const features = [
    {
      icon: 'ri-timer-flash-line',
      title: 'Save Time',
      desc: 'Find products faster with the Vigorbuy Spreadsheet. No more endless scrolling — curated collections at your fingertips.',
    },
    {
      icon: 'ri-stack-line',
      title: 'Better Organization',
      desc: 'Products are sorted by category in the Vigorbuy Spreadsheet, making it effortless to find exactly what you are looking for.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Better Decisions',
      desc: 'Compare products side by side in the Vigorbuy Spreadsheet before purchasing. Make informed choices every time.',
    },
    {
      icon: 'ri-fire-line',
      title: 'Updated Finds',
      desc: 'The Vigorbuy Spreadsheet is regularly refreshed with trending products and new discoveries across all categories.',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-3">
          Why Thousands of Users Search for Vigorbuy Spreadsheet
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-10 max-w-xl mx-auto">
          Discover why the Vigorbuy Spreadsheet has become the go-to resource for smart shoppers worldwide.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((f) => (
            <div key={f.title} className="bg-background-50 rounded-lg p-5 md:p-6 text-center">
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4">
                <i className={`${f.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}